const LoadingAnimation = props => {
    return (
        <div className="page-overlay">
            {props.message}
        </div>
    );
}
 
export default LoadingAnimation;